// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lFLGV","footer":"styles_footer__2Wl-D"};